export default __webpack_public_path__ + "static/media/Shape_left.3a0a848c.png";